// removed by extract-text-webpack-plugin
module.exports = {"binary_popover_header":"xus6QHxWxO_4k7rTXRS71","binary_comment_number":"_3qb2LkhOi52_2aaSw1pCyx","binary_comment_circle":"_3Z-BDcCycMJ49JiWZLs6uk","binary_popover_content":"_31zxmrs1l1-NkchmDKZD_D"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryPopover/BinaryPopover.scss
// module id = 2241
// module chunks = 1